import {css} from 'styled-components';

import type {StyledProps} from './types';

const base = css<StyledProps>`
  align-self: center;
`;

export const web = css<StyledProps>`
  box-sizing: border-box;
  ${base}
`;

export const native = css<StyledProps>`
  ${base}
`;
